/* eslint-disable */
import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import { getTernaryCondition } from 'common-ui-components/lib/core/utils/common';
import { get, isEmpty, forEach, toUpper, set, size, find } from 'lodash';
import API_URLS from '../../constants/api/services';
import API from '../../utils/fetch';
import log from '../../utils/logger';
import dataDogEvent from '../../utils/dataDogEvent';
import cartRecommendation from '../../utils/cartRecommendation';
import {
  GET_APPLICATION_PAGE_DATA,
  GET_ORDER_SUMMARY_DATA,
  GET_PROMO_CODE_DETAILS,
  USER_STATE_LOGGED_IN,
  USER_STATE_ANONYMOUS,
  LOGIN_COOKIE,
  USER_ID_KEY,
  SOLD_TO_KEY,
  SIGN_OUT,
  LOAD_SHOPPING_CART_DATA,
  DEFAULT_PATH_FORMAT,
  GET_COUNTRY_STATUS,
  SET_SWITCH_ACCOUNT,
  PUNCHOUT_LOGIN,
  SET_STORAGE_CART_ID,
  PUNCHOUT_SETUP,
  GET_PUNCHOUT_SETUP_DETAILS,
  ERROR_CODE,
  SET_STORAGE_CART_GUID,
  CART_URL,
  NOT_FOUND_URL,
  SEARCH_BAR_REQUEST,
  SETUP_FAILURE_STATUS_CODE,
  countryCommerceConfigContract,
  DISABLED_CART_MESSAGE,
  QUOTE_ID_KEY,
  CHECKOUT_URL,
  CLEAR_QUOTE_DATA,
  EPROC_USER_ROLE,
  ECOMM_USER_ROLE,
  DISMISS_SYSTEM_NOTIFICATION_STORAGE,
  QUICK_ORDER_URL,
  LOAD_USER_EMAIL,
  SUBMIT_FREIGHT_CHARGE_MODAL,
  FREIGHT_CHARGE_DETAILS,
  USER_AUTHORIZATION,
  USER_AUTHENTICATION,
  DEFAULT_FREIGHT_DETAILS,
  DISABLED_ORDER_ENABLE_QUOTE_MESSAGE,
  ALL,
  PHONE_NUMBER,
  PO_NUMBER,
  ATTENTION_TO,
  BUILDING_NUMBER,
  CREATE_SETUP_INTENT_ID,
} from '../constants';
import {
  setApplicationLabels,
  setOrderSummaryData,
  setPromoCodeDetails,
  setOrderSummaryDataError,
  setUserStatus,
  setUserDetails,
  setApplicationPageData,
  loadCountryDataSuccess,
  loadCountryDataFailure,
  LoadShoppingCartDataSuccess,
  LoadShoppingCartFailure,
  setGlobalErrorStatus,
  setCountryStatusSuccess,
  setCountryStatusFailure,
  searchBarRequestSuccess,
  punchoutSetupFailure,
  countryConfigSuccess,
  addQuoteDetailsData,
  systemNotificationSuccess,
  systemNotificationFailure,
  setFreightChargeModalStatus,
  userAuthorizationSuccess,
  shortTermTokenExpired,
  setShippingInfo,
  userAuthenticationClearData,
  loadEmptyCart,
  updateCustomPricing,
  setAnnouncementData,
  createSetupIntentIdSuccess,
  createSetupIntentIdFailure,
} from '../actions';
import {
  loadSoldToDetailsSuccess,
  loadUserDataSuccess,
  loadCheckoutDataSuccess,
  removeWholeCartSuccess,
  removeWholeCartFailure,
} from '../../containers/templates/Checkout/Checkout.actions';
import { loadQuoteDataSuccess } from '../../containers/templates/Quote/Quote.action';
import { validateQuoteCode } from '../../containers/templates/ShoppingCart/ShoppingCart.actions';
import {
  getCookie,
  getCartKey,
  isUserLoggedIn,
  getDefaultPathVar,
  getLabelsConfigData,
  getSoldToId,
  cartMergeStatus,
  setCartKey,
  signOut,
  parseQueryParams,
  isCountryEnabled,
  cartNotFoundStatus,
  removeQueryString,
  getUserDetailsFromContract,
  getLocalCountryLanguage,
  upgradeAEMPageContent,
  getViewCartURL,
  loadCartProxyStatus,
  getDefaultIsoCode,
  getDefaultLocaleCountry,
  isEProcurementApp,
  getCustomerBlockedError,
  showLoaderRestriction,
  getAppChannel,
  getUserId,
  redirectTo,
  removeCompetitionBlockedError,
} from '../../utils/utils';
import { getCountryCommerceConfigContract, getCreatedCustomerId } from '../../utils/extraUtils';
import {
  sessionGetItem,
  sessionSetItem,
  sessionRemoveItem,
  storageClear,
  storageSessionClear,
  setItem,
  removeItem,
  removeSessionItems,
  sessionGetItemValue,
  sessionSetItemValue,
  updateSessionStorage,
} from '../../utils/storage';
import { POST, DELETE } from '../../constants';
import {
  isFreightEnabled,
  GSTValidateInAddress,
  getSoldToData,
  getShippingInfo,
  matchListItems,
  getOrCondition,
} from '../../utils/utilFunctions';
const productErrorsList = [
  ERROR_CODE.WAT_SAP_028,
  ERROR_CODE.WAT_ERR_028,
  ERROR_CODE.WAT_SAP_907,
  ERROR_CODE.WAT_ERR_907,
  ERROR_CODE.WAT_SAP_906,
  ERROR_CODE.WAT_ERR_906,
];
const errExclusionList = [
  ERROR_CODE.WAT_COUPON,
  ERROR_CODE.WAT_ERR_400,
  ERROR_CODE.WAT_IMAGE_001,
  ERROR_CODE.WAT_ERR_0005,
  ERROR_CODE.WAT_IMAGE_PRODUCT_001,
  ERROR_CODE.WAT_ERR_0006,
  ERROR_CODE.WTR_ERR_001,
  ERROR_CODE.WAT_ERR_1001,
  ...productErrorsList,
];
const getCouponErrors = errors =>
  errors.filter(e => e.code.indexOf('WAT_COUPON') !== -1 || e.code.indexOf('WAT_ERR') !== -1);
const getProductErrors = errors =>
  errors ? errors.filter(e => productErrorsList.indexOf(e.code) !== -1) : [];
const getGlobalErrors = errors =>
  errors ? errors.filter(e => errExclusionList.indexOf(e.code) === -1) : [];
const globalErrorStatus = (persistGlobalError, globalErr, productError) => {
  if (globalErr.length > 0) {
    return globalErr[0];
  }
  if (productError.length > 0) {
    return productError[0];
  }
  return persistGlobalError;
};
const isUnavailableProduct = (errors = []) =>
  !isEmpty(
    errors.find(x => x.code === ERROR_CODE.WAT_SAP_382 || x.code === ERROR_CODE.WAT_ERR_382)
  );

const getErrorResponse = error => {
  try {
    return error.response.json().then(res => res);
  } catch (e) {
    return {};
  }
};
const clearCartKey = (error = []) => {
  const status = cartNotFoundStatus(error);
  if (status) {
    removeItem(SET_STORAGE_CART_ID);
    removeItem(SET_STORAGE_CART_GUID);
  }
};

export function* setGlobalErrorData(error) {
  if (!isEmpty(error)) {
    yield put(setGlobalErrorStatus({ error }));
  }
}

export function* updateShippingInfo(cartData) {
  const store = yield select();
  const carrierInfo = get(cartData, ['data', 'carrierInfo'], {});
  const entries = get(cartData, ['data', 'cart', 'entries'], '');
  const errors = get(cartData, ['errors'], []);
  const carrierName = get(carrierInfo, 'carrierName', '');
  const carrierNumber = get(carrierInfo, 'carrierNumber', '');
  const carrierDescription = get(carrierInfo, 'description', '');
  const country = get(store, ['global', 'globalData', 'countryData', '0', 'code'], '');
  const state = get(cartData, ['data', 'state'], '');
  const globalErrors = get(store, ['global', 'globalData', 'error'], []);
  const includesCompetitorError = globalErrors.findIndex(v => {
    return v.code == ERROR_CODE.WAT_ERR_117 || v.code == ERROR_CODE.WAT_ERR_046;
  });
  const shippingCarrierAndMethod = `${carrierName} ${carrierDescription}`;
  if (isEProcurementApp()) {
    sessionSetItem(DEFAULT_FREIGHT_DETAILS, {
      defaultState: state,
      defaultCarrierNumber: carrierNumber,
    });
    sessionSetItem(FREIGHT_CHARGE_DETAILS, {
      shippingCarrier: {
        carrierName: `${carrierName} ${carrierDescription}`,
        carrierNumber,
        name: shippingCarrierAndMethod,
      },
      country,
      state,
    });
  }
  if (!entries || errors.length === 0 || includesCompetitorError !== -1) {
    set(store, ['global', 'globalData', 'error'], removeCompetitionBlockedError(globalErrors));
  }
  yield put(setShippingInfo([shippingCarrierAndMethod, state, country]));
}

export function* fetchProductPricing(action) {
  try {
    if (action?.length > 0) {
      const productNumber = action.map(item => {
        return item?.id;
      });
      const store = yield select();
      const countryData = get(store, ['global', 'globalData', 'countryData'], {});
      const { localeCountry, localeLanguage } = getLocalCountryLanguage();
      const userId = getUserId() || 'anonymous';
      const customerNumber = getSoldToId() || 'anonymous';
      const salesOrg = countryData.salesOrg || '';
      const fields = isUserLoggedIn() ? 'FULL' : 'DEFAULT';
      const query = { productNumber: productNumber.join(','), customerNumber, userId, fields };
      if (!isEmpty(salesOrg)) {
        query.salesOrg = salesOrg;
      }
      const options = {
        fetchProps: {
          method: 'GET',
          credentials: 'include',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json',
            language: localeLanguage,
            countryCode: localeCountry,
            channel: getAppChannel(),
          },
        },
        query,
      };
      const response = yield call(API.fetch, API_URLS.pricingUrl, options);
      if (response && response.length > 0) {
        const res = matchListItems(response, action);
        yield put(updateCustomPricing(res));
      }
    }
  } catch (err) {
    const errorResponse = yield getErrorResponse(error);
    const errors = get(errorResponse, ['errors'], {});
    const errorData = get(errors, ['0'], {});
    yield put(setGlobalErrorStatus({ error: errorData }));
  }
}

export function* getProductRecommendation(cardData) {
  const data = yield cartRecommendation
    .callCartRecommendationEvent(cardData)
    .then(data => data)
    .catch(err => err);
  yield fetchProductPricing(data);
}

// eslint-disable-next-line complexity
export function* loadShoppingCartDataSaga(action) {
  if (isCountryEnabled()) {
    const store = yield select();
    const persistGlobalError = get(action, ['data', 'persistGlobalError'], {});
    const isFromHeaderQuickOrder = get(action, ['data', 'isFromHeaderQuickOrder'], false);
    const productRecommendationData = get(
      store,
      ['global', 'globalData', 'productRecommendationData'],
      []
    );
    const productRecommendationTitle = get(
      store,
      ['global', 'globalData', 'labels', 'productRecommendationTitle'],
      ''
    );
    try {
      const guid = getCartKey();
      const isUserLogin = isUserLoggedIn();
      const soldToId = getSoldToId();
      if (guid || isUserLogin) {
        const isCartMerge = cartMergeStatus();
        const query = { isCartMerge };
        if (!isEmpty(soldToId)) {
          query.soldToId = soldToId;
        }
        const { localeCountry, localeLanguage } = getLocalCountryLanguage();
        const { template } = getDefaultLocaleCountry();
        const channel = getAppChannel();
        const isLoadCartProxyStatus = loadCartProxyStatus(action, isCartMerge);
        const cartURL = isLoadCartProxyStatus ? API_URLS.shoppingCartProxy : API_URLS.shoppingCart;
        const options = {
          fetchProps: { action, credentials: 'include', mode: 'cors' },
          query: { ...query, localeCountry, localeLanguage, channel },
          pathVars: { guid, ...getDefaultPathVar() },
          showLoader: showLoaderRestriction(isFromHeaderQuickOrder),
        };
        const shippingInfo = getShippingInfo();
        const isAddedShippingInfo =
          isEProcurementApp() && isFreightEnabled() && !isEmpty(shippingInfo);

        if (isAddedShippingInfo) {
          options.query = { ...options.query, ...shippingInfo };
        }

        if (isEProcurementApp()) {
          options.query = { ...options.query, freightEnabled: isFreightEnabled() };
        }

        const res = yield call(API.fetch, cartURL, options);
        let data = get(res, ['data', 'cart'], {});
        if (isEmpty(data) && isLoadCartProxyStatus && template === QUICK_ORDER_URL) {
          data = get(res, ['cart'], {});
        }
        const code = get(data, ['code'], '');
        const cartGuid = get(data, ['guid'], '');
        const errors = get(res, ['errors'], []);
        const productErrors = getProductErrors(res.errors);
        const globalErrors = getGlobalErrors(res.errors);
        const isUnavailableProductError = isUnavailableProduct(res.errors);
        const err = globalErrorStatus(persistGlobalError, globalErrors, productErrors);
        clearCartKey(errors);
        if (!isEmpty(code) || !isEmpty(cartGuid)) {
          setCartKey({ code, guid: cartGuid });
        }
        yield put(LoadShoppingCartDataSuccess(data || {}, { productErrors, globalErrors }));
        if (data.totalItems === 0) {
          removeSessionItems([PHONE_NUMBER, BUILDING_NUMBER, PO_NUMBER, ATTENTION_TO]);
        }
        yield updateShippingInfo(res);
        if (!isEmpty(err) && !isUnavailableProductError) {
          const errorData = getCustomerBlockedError(err);
          yield put(setGlobalErrorStatus({ error: errorData }));
        }
        if (
          !isEProcurementApp() &&
          size(productRecommendationData) === 0 &&
          !isEmpty(productRecommendationTitle)
        ) {
          yield getProductRecommendation(data);
        }
      } else {
        if (
          !isEProcurementApp() &&
          size(productRecommendationData) === 0 &&
          !isEmpty(productRecommendationTitle)
        ) {
          yield getProductRecommendation({});
        }
        yield put(loadEmptyCart());
      }
    } catch (error) {
      const errorResponse = yield getErrorResponse(error);
      const errors = get(errorResponse, ['errors'], {});
      clearCartKey(errors);
      yield put(LoadShoppingCartFailure(errors));
    }
  }
}

export function* getDetailsLazy(prop, url) {
  let returnValue = sessionGetItem(prop);
  if (!returnValue) {
    const response = yield call(API.fetch, url, {
      fetchProps: { credentials: 'include', mode: 'cors' },
    });
    if (!response.failed) {
      let res = response;
      if (prop === USER_ID_KEY) {
        res = getUserDetailsFromContract(response);
      }
      sessionSetItem(prop, res);
      returnValue = res;
    }
  }
  return returnValue;
}

export function* loadCountryData() {
  if (isCountryEnabled()) {
    try {
      const defaultPathVar = getDefaultPathVar();
      const code = get(defaultPathVar, 'localeCountry', '');
      const options = {
        fetchProps: {},
        query: { states: true, shippingcarriers: true },
        pathVars: { code },
        showLoader: showLoaderRestriction(),
      };
      const data = yield call(API.fetch, API_URLS.country, options);
      const { salesOrg } = JSON.parse(sessionStorage.getItem('waters.userDetails'));
      let paymentInfo;
      if (data[0].payment && Array.isArray(data[0].payment)) {
        paymentInfo = data[0].payment.find(payment => payment.salesOrg.includes(salesOrg));
      }
      if (paymentInfo) {
        data.SP_PUBLIC_KEY = paymentInfo.publishableKey;
        data.allowedCardTypes = paymentInfo.cardsAccepted.join(',');
        sessionStorage.setItem('SP_PUBLIC_KEY', data.SP_PUBLIC_KEY);
        sessionStorage.setItem('allowedCardTypes', data.allowedCardTypes);
      }
      yield put(loadCountryDataSuccess(data));
    } catch (error) {
      yield put(loadCountryDataFailure(error));
    }
  }
}

export function* getPathvars() {
  const store = yield select();
  const defaultPath = DEFAULT_PATH_FORMAT.split('/');
  const pathVars = {};
  let pathname = get(store, ['global', 'globalData', 'route', 'location', 'pathname'], undefined);
  pathname = (pathname && pathname.split('/')) || [];
  forEach(pathname, (value, key) => {
    if (!isEmpty(value)) {
      pathVars[defaultPath[key]] = value;
    }
  });
  return pathVars;
}
export function* loadCountryStatus() {
  const apiUrl = `${API_URLS.getPageData}?pagePath=/${API_URLS.getCountryStatusPath}.html&depth=full`;
  const isUserLogin = isUserLoggedIn();
  try {
    const options = {
      fetchProps: {
        headers: {
          Accept: '*',
          'Content-Type': 'text/plain',
        },
      },
      pathVars: getDefaultPathVar(),
      showLoader: showLoaderRestriction(),
    };
    const data = yield call(API.fetch, apiUrl, options);
    data['Page Content'].viewCartUrl = getViewCartURL();
    yield put(setCountryStatusSuccess(data));
    if (!isUserLogin) {
      const countryData = get(data, 'Page Content', {});
      const response = getCountryCommerceConfigContract(countryData);
      yield put(countryConfigSuccess(response));
    }
  } catch (err) {
    yield put(setCountryStatusFailure(err));
  }
}
export function* loadCountryConfig() {
  const apiUrl = `${API_URLS.getPageData}?pagePath=/${API_URLS.getCountryStatusPath}.html&depth=full`;
  const countryCode = window.location.href.split('/')[4];
  const defaultPathVars = getDefaultPathVar();
  const localeCountry = countryCode === 'xg' ? 'xg' : defaultPathVars.localeCountry;
  try {
    const options = {
      fetchProps: {
        headers: {
          Accept: '*',
          'Content-Type': 'text/plain',
        },
      },
      pathVars: {
        ...defaultPathVars,
        localeCountry,
      },
      showLoader: showLoaderRestriction(),
    };
    const data = yield call(API.fetch, apiUrl, options);
    const countryData = get(data, 'Page Content', {});
    const response = getCountryCommerceConfigContract(countryData);
    yield put(countryConfigSuccess(response));
  } catch (err) {
    const response = {
      ...countryCommerceConfigContract,
      err,
    };
    yield put(countryConfigSuccess(response));
  }
}
export function* getSoldToFromPartnersApi(prop, userId, salesOrgVal, countryCodeVal, languageVal) {
  const returnValue = sessionGetItem(prop);
  if (!returnValue) {
    const store = yield select();
    const signInUrl = get(store, ['global', 'globalData', 'config', 'signInUrl'], '/#');
    const hasSoldTo = get(store, ['global', 'globalData', 'userDetails', 'soldTo'], []);
    if (isEmpty(hasSoldTo)) {
      const options = {
        fetchProps: { credentials: 'include', mode: 'cors' },
        query: { salesOrg: salesOrgVal, countryCode: countryCodeVal, language: languageVal },
        pathVars: getDefaultPathVar(),
        showLoader: showLoaderRestriction(),
        redirectUrl: signInUrl,
      };
      const partnersData = yield call(API.fetch, `${API_URLS.partnerInfo}${userId}`, options);
      const customers = partnersData.customers || [];

      const soldToData = [];
      const soldToForSession = [];
      customers.forEach(item => {
        const {
          soldToInfo,
          soldToFlag,
          name,
          customerNumber,
          salesOrg,
          displayCustomerNumber,
        } = item;
        if (
          !isEmpty(customerNumber) ||
          !isEmpty(name) ||
          !isEmpty(salesOrg) ||
          !isEmpty(soldToFlag)
        ) {
          soldToForSession.push(
            Object.assign({ customerNumber, name, salesOrg, soldToFlag, displayCustomerNumber })
          );
          soldToData.push(
            Object.assign({
              soldToInfo,
              soldToFlag,
              name,
              salesOrg,
              customerNumber,
              displayCustomerNumber,
            })
          );
        }
      });
      sessionSetItem(prop, soldToForSession);
      return { soldToData, partnersData, customers };
    }
  }
  return returnValue;
}
export function* clearQuoteData(action = {}) {
  const store = yield select();
  const sessionQuoteId = sessionGetItemValue(QUOTE_ID_KEY);
  const { template } = getDefaultLocaleCountry();
  const quoteData = get(store, ['global', 'globalData', 'quoteData'], '');
  const { isClearQuote = false } = action;
  if (template !== CHECKOUT_URL || isClearQuote) {
    if (!isEmpty(sessionQuoteId)) {
      sessionRemoveItem(QUOTE_ID_KEY);
    }
    if (!isEmpty(quoteData)) {
      yield put(addQuoteDetailsData({}));
    }
  }
}
export function* getUserStatus() {
  try {
    const data = getCookie(LOGIN_COOKIE);
    if (data) {
      yield put(setUserStatus(USER_STATE_LOGGED_IN));
      const userData = yield getDetailsLazy(USER_ID_KEY, API_URLS.userDetails);
      const localeCountry = get(userData, ['mailingAddressCountryCode'], '');
      const registeredCountry = toUpper(localeCountry);
      const { localeLanguage } = getLocalCountryLanguage();
      const soldTo = yield getSoldToFromPartnersApi(
        SOLD_TO_KEY,
        userData.userId,
        userData.salesOrg,
        registeredCountry,
        localeLanguage
      );
      const { soldToData, partnersData, customers } = soldTo;
      const userDetailData = { ...userData, ...{ soldTo: soldToData || soldTo } };
      yield put(setUserDetails(userDetailData));
      yield loadCountryConfig();
      const soldToId = getSoldToId();
      if (!isEmpty(soldToId) && !isEmpty(customers) && !isEmpty(partnersData)) {
        const partnerInfoData = customers.find(item => item.customerNumber === soldToId);
        yield put(loadSoldToDetailsSuccess(partnerInfoData));
        yield put(loadUserDataSuccess(partnersData));
      }
    } else {
      yield put(setUserStatus(USER_STATE_ANONYMOUS));
    }
    yield dataDogEvent.loadDataDogEvent();
    yield loadCountryData();
    yield clearQuoteData();
  } catch (err) {
    yield put(setUserStatus(USER_STATE_ANONYMOUS));
    yield loadCountryData();
    yield clearQuoteData();
    yield dataDogEvent.loadDataDogEvent();
  }
}

export function* loadSystemNotificationMessage() {
  try {
    const isEProcApp = isEProcurementApp();
    const channel = isEProcApp ? EPROC_USER_ROLE : ECOMM_USER_ROLE;
    const options = {
      fetchProps: {},
      query: { channel },
      pathVars: getLocalCountryLanguage(),
      showLoader: showLoaderRestriction(),
    };
    const notificationData = yield call(API.fetch, `${API_URLS.systemNotification}`, options);
    if (!isEmpty(notificationData)) {
      yield put(systemNotificationSuccess(notificationData));
    }
  } catch (error) {
    yield put(systemNotificationFailure(error));
  }
}

export function* getApplicationPageData() {
  const store = yield select();
  const apiUrl = `${API_URLS.getPageData}?pagePath=/${API_URLS.getPageDataPath}/cart-checkout.html&depth=full`;
  const apiAnnoucementBannerUrl = `${API_URLS.announcementNotification}`;

  try {
    const options = {
      fetchProps: {
        headers: {
          Accept: '*',
          'Content-Type': 'text/plain',
        },
      },
      pathVars: getDefaultPathVar(),
      showLoader: showLoaderRestriction(),
      isNextAPICall: getCartKey() || isUserLoggedIn(),
      suppressErrorNotification: true,
    };
    const bannerDetails = yield call(API.fetch, apiAnnoucementBannerUrl, options);
    //store announcement in redux
    yield put(setAnnouncementData(bannerDetails['entities']));
  } catch (error) {
    yield setGlobalErrorStatus([]);
  }

  try {
    const options = {
      fetchProps: {
        headers: {
          Accept: '*',
          'Content-Type': 'text/plain',
        },
      },
      pathVars: getDefaultPathVar(),
      showLoader: showLoaderRestriction(),
      isNextAPICall: getCartKey() || isUserLoggedIn(),
    };

    const pageData = yield call(API.fetch, apiUrl, options);

    const error = get(pageData, 'Error', undefined);
    if (!isEmpty(error)) {
      const history = get(store, ['global', 'globalData', 'route', 'history'], undefined);
      history.push(NOT_FOUND_URL);
    } else {
      const isNavigationV2Enabled =
        true || get(pageData, ['Page Content', 'isNavigationV2Enabled'], false);
      const navDataV2 = get(pageData, ['Navigation Content', 'items'], []);
      const domain = window.location.origin;
      if (isNavigationV2Enabled && !isEmpty(navDataV2) && window.Worker) {
        import('../../utils/navWorkerStart').then(workerInst => {
          workerInst.default({ navItems: navDataV2, domain });
        });
      }
      yield put(setApplicationPageData(pageData));
      let pageContent = get(pageData, ['Page Content', '_children'], []);
      if (pageContent.length === 0) {
        pageContent = upgradeAEMPageContent(pageData);
        yield put(setApplicationPageData(pageContent));
        pageContent = get(pageContent, ['Page Content', '_children'], []);
      }
      const labelsData = getLabelsConfigData(pageContent);
      yield put(setApplicationLabels(labelsData));
      yield getUserStatus();
      yield loadShoppingCartDataSaga();
      yield loadSystemNotificationMessage();
      const state = yield select();
      const { checkoutDisabled = false, quoteDisabled = false } = yield get(
        state,
        ['global', 'globalData', 'countryConfig'],
        {}
      );

      if (checkoutDisabled) {
        yield put(
          setGlobalErrorStatus({
            error: {
              code: quoteDisabled ? DISABLED_CART_MESSAGE : DISABLED_ORDER_ENABLE_QUOTE_MESSAGE,
            },
          })
        );
      }
    }
  } catch (err) {
    yield put(setApplicationPageData({}));
    yield getUserStatus();
  }
}

export function* signOutSaga(action) {
  const { signOutUrl } = action.data;
  try {
    signOut();
    yield call(API.fetch, API_URLS.signOut, {
      fetchProps: { credentials: 'include', mode: 'cors' },
    });
    const systemNotificationStatus = sessionGetItemValue(DISMISS_SYSTEM_NOTIFICATION_STORAGE);
    storageClear();
    storageSessionClear();
    if (!isEmpty(systemNotificationStatus)) {
      sessionSetItemValue(DISMISS_SYSTEM_NOTIFICATION_STORAGE, systemNotificationStatus);
    }
    window.location.href = signOutUrl;
  } catch (error) {
    // TBD
  }
}

export function* setOrderSummaryGlobalError(error) {
  const err = get(error, ['0'], {});
  const errorCode = get(error, ['0', 'code'], '');
  if (
    errorCode === ERROR_CODE.WAT_SAP_POSTAL_ERR_001 ||
    errorCode === ERROR_CODE.WAT_ERR_0001 ||
    errorCode === ERROR_CODE.WAT_SAP_000 ||
    errorCode === ERROR_CODE.WAT_ERR_000
  ) {
    const errorData = getCustomerBlockedError(err);
    yield put(setGlobalErrorStatus({ error: errorData }));
  }
}

export function* setOrderSummaryDataErrorStatus(error, orderSummaryData = {}) {
  const status = cartNotFoundStatus(error);
  if (status) {
    yield put(LoadShoppingCartDataSuccess({}));
    clearCartKey(error);
    const store = yield select();
    const history = get(store, ['global', 'globalData', 'route', 'history'], undefined);
    history.push(CART_URL);
  } else {
    yield put(setOrderSummaryDataError(orderSummaryData));
  }
  yield setOrderSummaryGlobalError(error);
}

export function* getOrderSummaryData(action) {
  try {
    const { body, remove } = action.data;
    const method = getTernaryCondition(remove, DELETE, POST);

    const guid = getCartKey();
    const soldToId = getSoldToId();

    const isCartMerge = cartMergeStatus();
    const query = { isCartMerge };
    if (!isEmpty(soldToId)) {
      query.soldToId = soldToId;
    }
    const { localeCountry, localeLanguage } = getLocalCountryLanguage();
    const channel = getAppChannel();
    const options = {
      fetchProps: {
        body,
        method,
        credentials: 'include',
        mode: 'cors',
      },
      query: { soldToId, localeCountry, localeLanguage, channel },
      pathVars: { guid, ...getDefaultPathVar() },
      showLoader: true,
    };
    const data = yield call(API.fetch, API_URLS.orderSummaryData, options);
    let orderSummaryData = {
      totalDiscounts: null,
      coupons: [],
      couponErrors: null,
    };
    if (data.errors && data.errors.length > 0) {
      if (data.data && data.data.cart) {
        if (remove) {
          orderSummaryData = {
            ...orderSummaryData,
            ...data.data.cart,
            ...{ errors: data.errors[0] },
          };
          yield put(
            setOrderSummaryData({
              orderSummaryData,
              requestData: action.data,
            })
          );
        } else {
          orderSummaryData = {
            cart: {
              errors: data.errors[0],
              ...orderSummaryData,
              ...data.data.cart,
            },
          };
          yield put(
            setOrderSummaryData({
              requestData: action.data,
            })
          );
          yield put(setOrderSummaryDataError(orderSummaryData));
        }
      } else {
        const error = get(data, ['errors'], []);
        orderSummaryData = {
          cart: {
            errors: error[0],
            couponErrors: getCouponErrors(error),
          },
        };
        yield setOrderSummaryDataErrorStatus(error, orderSummaryData);
      }
      yield setOrderSummaryGlobalError(data.errors);
    } else {
      orderSummaryData = data.data.cart ? { ...orderSummaryData, ...data.data.cart } : {};

      yield put(setOrderSummaryData({ orderSummaryData, requestData: action.data }));
    }
  } catch (error) {
    const errorResponse = yield getErrorResponse(error);
    const errors = get(errorResponse, ['errors'], {});
    yield setOrderSummaryDataErrorStatus(errors);
    yield put(setOrderSummaryData({}));
  }
}

export function* getPromoCodeDetailsSaga(action) {
  try {
    const { localeCountry, localeLanguage } = getLocalCountryLanguage();
    const options = {
      fetchProps: {},
      query: { localeCountry, localeLanguage },
      pathVars: Object.assign({ promoCode: action.data }, getDefaultPathVar()),
      showLoader: false,
    };
    const data = yield call(API.fetch, API_URLS.getPromoCodeDetails, options);
    yield put(setPromoCodeDetails(data));
  } catch (error) {
    yield put(setPromoCodeDetails({}));
  }
}

export function* switchAccountSaga(action) {
  try {
    const { data, onSuccess } = action;
    const options = {
      fetchProps: { credentials: 'include', mode: 'cors', method: POST },
      pathVars: { soldTo: data },
      showLoader: false,
    };
    const successData = yield call(API.fetch, API_URLS.setSwitchAccount, options);
    if (successData) {
      onSuccess();
      removeSessionItems([PHONE_NUMBER, BUILDING_NUMBER, PO_NUMBER, ATTENTION_TO]);
    }
  } catch (error) {
    //  Nothing to do
  }
}

function* errorSetupFailure(code = SETUP_FAILURE_STATUS_CODE) {
  try {
    const store = yield select();
    const modalStatus = get(store, ['global', 'globalData', 'setupFailure', 'status'], false);
    if (!modalStatus) {
      const punchoutSetupDetails = sessionGetItem(PUNCHOUT_SETUP);
      yield put(
        punchoutSetupFailure({
          status: true,
          code,
          redirectUrl:
            punchoutSetupDetails && punchoutSetupDetails.redirectUrl
              ? punchoutSetupDetails.redirectUrl
              : '',
        })
      );
    }
  } catch (err) {
    log(err);
  }
}

export function* getCartSetupDetails() {
  try {
    const urlParams = parseQueryParams(window.location.search);
    if (urlParams.sid) {
      sessionRemoveItem(PUNCHOUT_SETUP);
      sessionRemoveItem(FREIGHT_CHARGE_DETAILS);
      sessionRemoveItem(DEFAULT_FREIGHT_DETAILS);
      const options = {
        fetchProps: { method: 'GET' },
        pathVars: { sid: urlParams.sid || '', userId: 'anonymous' },
      };
      const data = yield call(API.fetch, API_URLS.getSetupDetails, options);
      if (data.errors && data.errors.length > 0) {
        yield errorSetupFailure(); // Something went wrong!
      } else {
        setItem(SET_STORAGE_CART_ID, data.cartId);
        sessionSetItem(PUNCHOUT_SETUP, {
          returnUrl: data.return_url,
          redirectUrl: data.redirect_url,
          buyerOrgName: data.buyerOrgName,
          currency: data.currency,
          country: data.country,
          freightEnabled: data.freightEnabled,
          state: data.state,
          selectedCarrierNumber: data.selectedCarrierNumber,
          selectedState: data.selectedState,
        });
      }
    } else if (!sessionGetItem(PUNCHOUT_SETUP)) {
      yield errorSetupFailure();
    }
  } catch (error) {
    if (error && error.response) {
      const res = yield error.response.json();
      yield errorSetupFailure(res.code || SETUP_FAILURE_STATUS_CODE);
    } else {
      yield errorSetupFailure();
    }
  }
  removeQueryString(window.location.href, 'sid', true);
}
function* setPunchoutError(error) {
  if (!sessionGetItem(PUNCHOUT_SETUP)) yield getCartSetupDetails();
  if (error && error.response) {
    const res = yield error.response.json();
    yield errorSetupFailure(res.code || SETUP_FAILURE_STATUS_CODE);
  } else {
    yield errorSetupFailure();
  }
}
export function* punchoutLogin() {
  try {
    const urlParams = parseQueryParams(window.location.search);
    const userLoginCookie = getCookie(LOGIN_COOKIE);
    if (urlParams['1tu']) {
      sessionRemoveItem(USER_ID_KEY);
      sessionRemoveItem(SOLD_TO_KEY);
      const options = {
        fetchProps: {
          body: { token: urlParams['1tu'] },
          method: 'POST',
          credentials: 'include',
          mode: 'cors',
        },
      };
      const response = yield call(API.fetch, API_URLS.punchoutLogin, options);
      const errors = get(response, ['errors', '0'], {});
      if (!isEmpty(errors)) {
        yield setPunchoutError();
      }
    } else if (!userLoginCookie) {
      sessionRemoveItem(USER_ID_KEY);
      sessionRemoveItem(SOLD_TO_KEY);
      yield setPunchoutError();
    }
  } catch (error) {
    yield setPunchoutError(error);
  }
  removeQueryString(window.location.href, '1tu', true);
}
export function* getSearchBarResult(action) {
  const { term, rows, sort, isoCode, category } = action.data;
  try {
    const options = {
      fetchProps: {},
      query: {
        isocode: isoCode || getDefaultIsoCode(),
        term,
        rows,
        sort,
        category,
        reference: ALL,
      },
      pathVars: {},
      showLoader: false,
    };
    const store = yield select();
    const searchViewConfig = get(
      store,
      ['global', 'globalData', 'countryStatus', 'Page Content', 'searchViewConfig'],
      ''
    );
    if (isEProcurementApp()) {
      options.query.reference = 'sku';
    } else {
      options.query.reference = !isEmpty(searchViewConfig) ? searchViewConfig : ALL;
    }

    const data = yield call(API.fetch, API_URLS.searchBar, options);
    yield put(searchBarRequestSuccess(data));
  } catch (error) {
    //
  }
}
export function* getUserEmail() {
  try {
    const store = yield select();
    let countryData = get(store, ['global', 'globalData', 'countryData'], {});
    countryData = (!isEmpty(countryData) && countryData[0]) || {};
    const defaultPathVar = getDefaultPathVar();
    const { localeCountry } = defaultPathVar;
    const { localeLanguage } = getLocalCountryLanguage();
    const registeredCountry = toUpper(localeCountry);
    const options = {
      fetchProps: { credentials: 'include', mode: 'cors' },
      query: {
        salesOrg: countryData.salesOrg,
        countryCode: registeredCountry,
        language: localeLanguage,
      },
      pathVars: defaultPathVar,
      showLoader: true,
    };
    const userData = yield call(API.fetch, API_URLS.partnerInfo, options);
    const email = get(userData, 'email');
    if (!isEmpty(email)) {
      const getUserDetails = get(store, ['global', 'globalData', 'userDetails'], []);
      yield put(setUserDetails({ ...getUserDetails, email }));
    }
  } catch (error) {
    log(error);
  }
}

function* handleSetupIntentErrors(res, errors, callback) {
  if (!isEmpty(errors)) {
    yield put(createSetupIntentIdFailure(res.error));
    if (callback) callback(false);
  } else {
    yield put(createSetupIntentIdSuccess(res));
    if (callback) callback(true);
  }
}

export function* createSetupIntentId(action) {
  const { userId, countryCode, callback } = action.data;
  try {
    let stripeCustomerId = null;
    const { firstName, lastName, sfContactId, spCustomerId, encryptedEmail, salesOrg } = JSON.parse(
      sessionStorage.getItem('waters.userDetails')
    );
    stripeCustomerId = spCustomerId;
    if (getOrCondition(stripeCustomerId == null, stripeCustomerId === undefined)) {
      stripeCustomerId = yield getCreatedCustomerId(
        userId,
        encryptedEmail,
        firstName,
        lastName,
        sfContactId,
        countryCode,
        stripeCustomerId
      );
      if (getOrCondition(stripeCustomerId === null, stripeCustomerId === undefined)) {
        yield put(setGlobalErrorStatus('Error in creating customer Id'));
      }
    }
    if (getOrCondition(stripeCustomerId !== null, stripeCustomerId !== undefined)) {
      const body = { spCustomerId: stripeCustomerId, webUserId: userId, countryCode: countryCode };
      const fetchProps = {
        body,
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
          salesOrg,
        },
      };
      const options = {
        fetchProps,
        pathVars: getDefaultPathVar(),
        showLoader: true,
      };
      const res = yield call(API.fetch, API_URLS.createSetupIntentId, options);
      const errors = get(res, ['error', '0'], {});
      yield call(handleSetupIntentErrors, res, errors, callback);
    }
  } catch (error) {
    yield put(createSetupIntentIdFailure({ ...error }));
    if (callback) callback(false);
  }
}

function* persistDeliveryMethod(carrierInfo) {
  try {
    if (!isEmpty(carrierInfo)) {
      const carrierName = get(carrierInfo, 'shippingCarrier.carrierName', '');
      const partnerNumber = get(carrierInfo, 'shippingCarrier.carrierNumber', '');
      const name = get(carrierInfo, 'shippingCarrier.name', '');
      if (!isEmpty(carrierName) && !isEmpty(partnerNumber) && !isEmpty(name)) {
        const { localeCountry, localeLanguage } = getLocalCountryLanguage();
        const userId = getUserId();
        const guid = getCartKey();
        const options = {
          fetchProps: {
            body: { carrierName, partnerNumber, name },
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
          },
          pathVars: { localeCountry, localeLanguage, userId, guid },
        };
        yield call(API.fetch, API_URLS.setDeliveryMethod, options);
      }
    }
  } catch (error) {
    log(error);
  }
}
export function* submitFreightChargeModal(action) {
  try {
    sessionSetItem(FREIGHT_CHARGE_DETAILS, action.data);
    yield put(setFreightChargeModalStatus(false));
    yield loadShoppingCartDataSaga();
    yield persistDeliveryMethod(action.data);
  } catch (error) {
    log(error);
  }
}
export function* userAuthorization(action) {
  try {
    const { data: body } = action;
    const fetchProps = {
      body,
      method: POST,
      credentials: 'include',
      mode: 'cors',
    };
    const options = {
      fetchProps,
      query: {},
      pathVars: getDefaultPathVar(),
      showLoader: true,
      skipUnAuthenticationError: true,
    };
    const res = yield call(API.fetch, API_URLS.signIn, options);
    yield put(userAuthorizationSuccess(res));
    yield put(shortTermTokenExpired({}));
    const store = yield select();
    const userAuthenticationData = get(store, ['global', 'globalData', 'userAuthentication'], {});
    const {
      redirectToURL,
      isCheckoutOrderSimulateFailed = false,
      isCreateQuoteOrderSimulateFailed = false,
    } = userAuthenticationData;
    const history = get(store, ['global', 'globalData', 'route', 'history']);
    if (!isEmpty(redirectToURL) && history) {
      yield put(userAuthenticationClearData({}));
      history.push(redirectToURL);
    }
    if (isCheckoutOrderSimulateFailed) {
      yield put(userAuthenticationClearData({ callCheckoutOrderSimulate: true }));
    }
    if (isCreateQuoteOrderSimulateFailed) {
      yield put(userAuthenticationClearData({ callCreateQuoteOrderSimulate: true }));
    }
  } catch (error) {
    if (error && error.response) {
      const res = yield error.response.json();
      yield put(setGlobalErrorStatus({ error: res }));
      yield put(userAuthorizationSuccess(res));
    }
  }
}
export function* userAuthentication(action) {
  try {
    const { data } = action;
    const { redirectToURL, onValidateQuote } = data;
    const store = yield select();
    const encryptedEmail = get(store, ['global', 'globalData', 'userDetails', 'encryptedEmail']);
    const fetchProps = {
      credentials: 'include',
      mode: 'cors',
      method: POST,
      body: { email: encryptedEmail },
    };
    const options = {
      fetchProps,
      query: {},
      pathVars: getDefaultPathVar(),
      showLoader: true,
      isNextAPICall: !isEmpty(onValidateQuote),
    };
    const res = yield call(API.fetch, API_URLS.userAuthentication, options);
    if (res && redirectToURL) {
      yield put(userAuthenticationClearData({}));
      redirectTo(redirectToURL);
    }

    if (res && !isEmpty(onValidateQuote)) {
      yield put(userAuthenticationClearData({}));
      yield put(validateQuoteCode({ ...onValidateQuote }));
    }
  } catch (error) {
    const errorResponse = yield getErrorResponse(error);
    const errors = get(errorResponse, ['errors'], {});
    const errorData = get(errors, ['0'], {});
    yield put(setGlobalErrorStatus({ error: errorData }));
  }
}

export function* loadCheckoutSaga() {
  try {
    const store = yield select();
    const checkoutDataInStore = get(store, ['checkout', 'checkoutData'], {});
    let userEmail = get(store, ['checkout', 'checkoutData', 'userDetails', 'email'], '');

    const isGSTEnabled = get(
      store,
      ['global', 'globalData', 'countryConfig', 'isGSTEnabled'],
      false
    );
    // If Checkout Data Not Available In Store Hit The Partners API
    if (isEmpty(checkoutDataInStore)) {
      let countryData = get(store, ['global', 'globalData', 'countryData'], {});
      countryData = (!isEmpty(countryData) && countryData[0]) || {};
      const defaultPathVar = getDefaultPathVar();
      const { localeCountry } = defaultPathVar;
      const { localeLanguage } = getLocalCountryLanguage();
      const registeredCountry = toUpper(localeCountry);
      const signInUrl = get(store, ['global', 'globalData', 'config', 'signInUrl'], '/#');
      const soldTo = getSoldToId();
      const options = {
        fetchProps: { credentials: 'include', mode: 'cors' },
        query: {
          salesOrg: countryData.salesOrg,
          countryCode: registeredCountry,
          language: localeLanguage,
        },
        pathVars: defaultPathVar,
        showLoader: true,
        redirectUrl: signInUrl,
      };
      const checkoutData = yield call(API.fetch, API_URLS.partnerInfo, options);
      userEmail = checkoutData?.email;
      const customers = checkoutData.customers || [];
      const partnerData = customers.find(item => item.customerNumber === soldTo);

      const soldToArr = getSoldToData(customers);
      const getUserDetails = get(store, ['global', 'globalData', 'userDetails'], []);
      yield put(setUserDetails({ ...getUserDetails, soldTo: soldToArr }));
      yield put(loadCheckoutDataSuccess(partnerData));
      yield put(loadQuoteDataSuccess(partnerData));
      yield put(loadUserDataSuccess(checkoutData));
      yield GSTValidateInAddress(partnerData, isGSTEnabled);
    } else {
      yield GSTValidateInAddress(checkoutDataInStore, isGSTEnabled);
    }
  } catch (error) {
    yield put(loadCheckoutDataSuccess({}));
    log(error);
  }
}
export function* clearCartData(error) {
  let status = false;
  const cartNotFound = cartNotFoundStatus(error);
  if (cartNotFound) {
    status = true;
    clearCartKey();
    yield put(LoadShoppingCartDataSuccess({}));
  }
  return status;
}

export function* loadShoppingCartDataForQuote(action) {
  let cartFoundStatus = false;
  try {
    const guid = getCartKey();
    const isUserLogin = isUserLoggedIn();
    const soldToId = getSoldToId();
    if (guid || isUserLogin) {
      const channel = getAppChannel();
      const { localeCountry, localeLanguage } = getLocalCountryLanguage();
      const options = {
        fetchProps: { action, credentials: 'include', mode: 'cors' },
        query: { soldToId, fields: 'BASIC', channel, localeCountry, localeLanguage },
        pathVars: { guid, ...getDefaultPathVar() },
        showLoader: true,
        isNextAPICall: true,
      };
      const res = yield call(API.fetch, API_URLS.shoppingCartProxy, options);
      const errors = get(res, ['errors'], []);
      cartFoundStatus = yield clearCartData(errors);
      return cartFoundStatus;
    }
  } catch (error) {
    const errorResponse = yield getErrorResponse(error);
    const errors = get(errorResponse, ['errors'], {});
    cartFoundStatus = yield clearCartData(errors);
    return cartFoundStatus;
  }
  return cartFoundStatus;
}
export function* removeWholeCart() {
  try {
    const guid = getCartKey();
    const fetchProps = {
      method: DELETE,
      credentials: 'include',
      mode: 'cors',
    };
    const channel = getAppChannel();
    const { localeCountry, localeLanguage } = getLocalCountryLanguage();
    const options = {
      fetchProps,
      query: { isWholeCart: true, channel, localeCountry, localeLanguage },
      pathVars: { guid, ...getDefaultPathVar() },
      showLoader: true,
    };
    const res = yield call(API.fetch, API_URLS.removeCart, options);
    const data = get(res, ['success'], false);
    if (!data) {
      yield put(removeWholeCartFailure(data));
    } else {
      yield put(removeWholeCartSuccess(res));
      removeItem(SET_STORAGE_CART_ID);
    }
  } catch (error) {
    log(error);
  }
}

export default function* globalSaga() {
  yield all([
    takeLatest(PUNCHOUT_LOGIN, punchoutLogin),
    takeLatest(GET_APPLICATION_PAGE_DATA, getApplicationPageData),
    takeLatest(GET_COUNTRY_STATUS, loadCountryStatus),
    takeLatest(LOAD_SHOPPING_CART_DATA, loadShoppingCartDataSaga),
    takeLatest(GET_ORDER_SUMMARY_DATA, getOrderSummaryData),
    takeLatest(GET_PROMO_CODE_DETAILS, getPromoCodeDetailsSaga),
    takeLatest(SIGN_OUT, signOutSaga),
    takeLatest(SET_SWITCH_ACCOUNT, switchAccountSaga),
    takeLatest(GET_PUNCHOUT_SETUP_DETAILS, getCartSetupDetails),
    takeLatest(SEARCH_BAR_REQUEST, getSearchBarResult),
    takeLatest(CLEAR_QUOTE_DATA, clearQuoteData),
    takeLatest(LOAD_USER_EMAIL, getUserEmail),
    takeLatest(SUBMIT_FREIGHT_CHARGE_MODAL, submitFreightChargeModal),
    takeLatest(USER_AUTHORIZATION, userAuthorization),
    takeLatest(USER_AUTHENTICATION, userAuthentication),
    takeLatest(CREATE_SETUP_INTENT_ID, createSetupIntentId),
  ]);
}
